import _ from 'lodash'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useUpdate } from 'react-admin'
import Papa from 'papaparse'

import dataset from '../resources/import-product/dataset'

export const useImportProduct = ({
  productType,
}: {
  productType: string
}): {
  handleClose: () => void
  handleSubmit: (e) => Promise<void>
  loading: boolean
  progress: number
  progressDialog: boolean
  importResultLists: object[]
} => {
  const record = useRef(new Map())

  const [loading, setLoading] = useState(false)
  // const [progressDialog, setProgressDialog] = useState<boolean>(true)
  const [progressDialog, setProgressDialog] = useState<boolean>(false)
  const [progress, setProgress] = useState<number>(0.0)
  const [currentIndex, setCurrentIndex] = useState<number>(-1)

  const [importResultLists, setImportResultLists] = useState([])

  const csvFileToArray = (string): object[] => {
    const result = Papa.parse(string, { header: true })

    return _.map(result?.data, (o) => {
      return _.transform(
        o,
        (result, value, key) => {
          if (_.includes(value, ';')) {
            _.set(result, [key], _.split(value, ';'))
          } else {
            _.set(result, key, value)
          }
        },
        {},
      )
    })
  }

  const upImportResult = useCallback(
    async (isSuccess: boolean, errorMessage?: string): Promise<void> => {
      const productLists = record.current.get('productLists')
      const p = productLists?.[currentIndex]

      setCurrentIndex(currentIndex + 1)
      setImportResultLists([
        {
          record: p,
          isSuccess,
          errorMessage,
        },
        ...importResultLists,
      ])
    },
    [currentIndex, importResultLists],
  )
  const onError = useCallback(
    (error): void => {
      upImportResult(false, error?.response?.data?.message)
    },
    [upImportResult],
  )

  const onSuccess = useCallback(async (): Promise<void> => {
    upImportResult(true)
  }, [upImportResult])

  const [update] = useUpdate(undefined, undefined, { onError, onSuccess })

  const upload = useCallback(async (): Promise<void> => {
    const images = record.current.get('images')
    const productLists = record.current.get('productLists')
    const productListsCount = record.current.get('productListsCount')

    const p = productLists?.[currentIndex]
    if (p) {
      const updateData = {
        // prod_name_en: 'เทสยาง 3',
        ..._.pick(p, dataset?.[_.camelCase(productType)] || []),
        prod_name_en: p?.prod_name_en ?? p?.prod_name_th,
        image: images?.[p?.image],
        thumbnail: images?.[p?.thumbnail],
        detail_image: images?.[p?.detail_image],
        warranty_image: images?.[p?.warranty_image],
        slug_th: p?.slug_th ? _.trim(p?.slug_th) : _.trim(p?.prod_name_th),
        slug_en: p?.slug_en ? _.trim(p?.slug_en) : _.trim(p?.prod_name_en ?? p?.prod_name_th),
      }

      await update(productType, {
        id: p?.id,
        // id: '1000020777',
        data: { encType: 'multipart/form-data', ...updateData },
      })

      setProgress(((currentIndex + 1) * 100) / productListsCount)
    }
    // else {
    //   setProgress(0)
    //   setLoading(false)
    //   setProgressDialog(false)

    //   record.current.delete('images')
    //   record.current.delete('productLists')
    //   record.current.delete('productListsCount')
    //   setCurrentIndex(-1)
    //   setImportResultLists([])
    // }
  }, [update, currentIndex, productType])

  const handleClose = useCallback((): void => {
    setProgress(0)
    setLoading(false)
    setProgressDialog(false)

    record.current.delete('images')
    record.current.delete('productLists')
    record.current.delete('productListsCount')
    setCurrentIndex(-1)
    setImportResultLists([])
  }, [])

  const handleSubmit = useCallback(async (e): Promise<void> => {
    const fileReader = new FileReader()
    setLoading(true)
    setProgressDialog(true)
    fileReader.onload = function (event): void {
      const images = _.mapKeys(e?.images, (o) => {
        return o?.title
      })
      const text = event.target.result
      const productLists = csvFileToArray(text)
      record.current.set('images', images)
      record.current.set('productLists', productLists)
      record.current.set('productListsCount', _.size(productLists))
      setCurrentIndex(0)
    }
    fileReader.readAsText(e?.csv?.rawFile)
  }, [])

  useEffect(() => {
    if (currentIndex > -1) {
      upload()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex])

  return { loading, progress, progressDialog, importResultLists, handleSubmit, handleClose }
}
